import { clearAuth } from '@/services/IdentityService';
import { persistor } from '@/store';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Dispatch } from 'redux';

const Logout: React.FC = () => {
    const history = useHistory();
    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        clearAuth();
        persistor.purge();
        history.push('/login');
    }, [dispatch, history]);

    return <></>;
};

export default Logout;
